export const getMtimeString = (thumbUrl: string, mtime?: string): string => {
    return mtime ? `${thumbUrl}${thumbUrl.includes('?') ? '&' : '?'}mt=${mtime}` : thumbUrl;
};
